import { render, staticRenderFns } from "./NewSupportSolution.vue?vue&type=template&id=3f5171e4&"
import script from "./NewSupportSolution.vue?vue&type=script&lang=js&"
export * from "./NewSupportSolution.vue?vue&type=script&lang=js&"
import style0 from "./NewSupportSolution.vue?vue&type=style&index=0&id=3f5171e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports